// Central workflow definition shared across the UI.

export const WORKFLOW_FULL = ["draft", "confirmation", "approval_1", "approval_2", "audit", "accounts", "unpaid"];
export const WORKFLOW_HR = ["draft", "confirmation", "approval_1", "accounts", "unpaid"];

export const APPROVAL_STAGES = ["confirmation", "approval_1", "approval_2", "audit", "accounts"];

export const WORKFLOW_OPTIONS = [
  ["confirmation", "Confirmation"],
  ["approval_1", "1st Approval"],
  ["approval_2", "2nd Approval"],
  ["audit", "Audit Approval"],
  ["accounts", "Accounts Approval"],
];
export const WORKFLOW_STAGE_LABEL = Object.fromEntries(WORKFLOW_OPTIONS);

export const stagesFor = (voucher) => {
  const wf = voucher?.workflow_stages;
  if (wf && wf.length) {
    const ordered = APPROVAL_STAGES.filter((s) => wf.includes(s));
    if (ordered.length) return ["draft", ...ordered, "unpaid"];
  }
  const type = typeof voucher === "string" ? voucher : voucher?.voucher_type;
  return type === "HR" ? WORKFLOW_HR : WORKFLOW_FULL;
};

// Which role acts on each actionable stage
export const STAGE_ROLE = {
  draft: "creator",
  confirmation: "confirmer",
  approval_1: "approver1",
  approval_2: "approver2",
  audit: "auditor",
  accounts: "accounts",
};

// Button label for advancing FROM a given stage
export const ADVANCE_LABEL = {
  draft: "Submit",
  confirmation: "Confirm",
  approval_1: "1st Approve",
  approval_2: "2nd Approve",
  audit: "Audit Approve",
  accounts: "Accounts Approve",
};

// Short step name for the stepper
export const STEP_LABEL = {
  draft: "Creator",
  confirmation: "Confirmation",
  approval_1: "1st Approval",
  approval_2: "2nd Approval",
  audit: "Audit Approval",
  accounts: "Accounts Approval",
  unpaid: "Unpaid",
};

export const STATUS_META = {
  draft: { label: "Draft", badge: "bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700" },
  confirmation: { label: "Pending Confirmation", badge: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/50 dark:text-blue-300 dark:border-blue-800" },
  approval_1: { label: "Pending 1st Approval", badge: "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950/50 dark:text-indigo-300 dark:border-indigo-800" },
  approval_2: { label: "Pending 2nd Approval", badge: "bg-violet-50 text-violet-700 border-violet-200 dark:bg-violet-950/50 dark:text-violet-300 dark:border-violet-800" },
  audit: { label: "Pending Audit Approval", badge: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/50 dark:text-amber-300 dark:border-amber-800" },
  accounts: { label: "Pending Accounts Approval", badge: "bg-cyan-50 text-cyan-700 border-cyan-200 dark:bg-cyan-950/50 dark:text-cyan-300 dark:border-cyan-800" },
  info_requested: { label: "Info Requested", badge: "bg-yellow-50 text-yellow-800 border-yellow-300 dark:bg-yellow-950/50 dark:text-yellow-300 dark:border-yellow-800" },
  unpaid: { label: "Unpaid", badge: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950/50 dark:text-orange-300 dark:border-orange-800" },
  paid: { label: "Paid", badge: "bg-emerald-600 text-white border-emerald-700 dark:bg-emerald-500 dark:text-white dark:border-emerald-600" },
};

export const statusLabel = (s) => STATUS_META[s]?.label || s;

// Can the current user act on a voucher at the given status?
export const canAct = (user, status) =>
  !!user && (user.role === "admin" || user.role === STAGE_ROLE[status]);

export const ROLE_LABEL = {
  admin: "Admin",
  creator: "Creator",
  confirmer: "Confirmer",
  approver1: "1st Approver",
  approver2: "2nd Approver",
  auditor: "Auditor",
  accounts: "Accounts",
};

export const ROLE_OPTIONS = ["creator", "confirmer", "approver1", "approver2", "auditor", "accounts", "admin"];

export const PAYMENT_METHODS = [
  ["cash", "Cash"], ["cheque", "Cheque"], ["bank", "Bank Transfer"], ["sadad", "SADAD"], ["credit_card", "Credit Card"],
];
export const PAYMENT_METHOD_LABEL = Object.fromEntries(PAYMENT_METHODS);

export const PAYMENT_TYPES = [
  ["invoice", "Invoice Payment"], ["advance", "Advance Payment"], ["on_account", "On Account"], ["balance", "Balance Payment"],
];
export const PAYMENT_TYPE_LABEL = Object.fromEntries(PAYMENT_TYPES);

export const CURRENCIES = [
  ["SAR", "SAR"], ["AED", "AED (Dirham)"], ["USD", "USD"], ["EUR", "EUR"], ["GBP", "GBP"],
];
